const projects = [
  {
    slug: "mekina-kiray-dotcom",
    imgSrc: "/assets/project10.png",
    title: "Mekina Kiray Dotcom - Vehicle Sales and Rental Platform",
    tags: ["React", "TailwindUI", "ShadcnUI", "NodeJs", "ExpressJs", "MySql"],
    description:
      "A full-stack vehicle sales and rental platform that connects sellers with buyers. Built with a modern React frontend and a Node.js API, it supports vehicle listings, applications, and an admin workflow for managing posts.",
    features: [
      "Vehicle listings with search and filtering",
      "Seller and buyer dashboards",
      "Secure authentication and role-based access",
      "Responsive UI with Tailwind and Shadcn components",
      "RESTful API backed by MySql",
    ],
    screenshots: [
      "/assets/project10.png",
      "/assets/project11.png",
      "/assets/mekina03.png",
      "/assets/mekina04.png",
      "/assets/mekina05.png",
      "/assets/mekina06.png",
      "/assets/mekina07.png",
    ],
    websiteLink: "https://mekinakiray.com",
    githubLink: "https://github.com/gayalew/mkd_frontend",
    category: "company",
    company: "Tankwa Tours & Travels | Bahir Dar University - BiT",
  },
  {
    slug: "gojoradar",
    imgSrc: "/assets/project12.png",
    title: "Gojoradar - Property Marketplace",
    tags: [
      "React",
      "TailwindUI",
      "ShadcnUI",
      "NodeJs",
      "ExpressJs",
      "Postgresql",
    ],
    description:
      "Gojoradar is a property marketplace where users can browse, list, and discover real estate. The app pairs a polished React interface with a scalable Node.js backend and PostgreSQL database.",
    features: [
      "Property listings with rich detail pages",
      "Search, filters, and map-friendly layouts",
      "User accounts and saved listings",
      "Admin tools for managing inventory",
      "PostgreSQL for reliable relational data",
    ],
    screenshots: [
      "/assets/project12.png",
      "/assets/project13.png",
      "/assets/gojo2.png",
      "/assets/gojo3.png",
      "/assets/gojo4.png",
    ],
    websiteLink: "https://gojoradar.com",
    githubLink: "https://github.com/gayalew/gojoradar",
    category: "company",
    company: "Tankwa Tours & Travels | Bahir Dar University - BiT",
  },
  {
    slug: "tankwa_vacancy",
    imgSrc: "/assets/tankwa01.png",
    title: "Tankwa Vacancy - Job Board",
    tags: ["JavaScript", "PHP", "MySQL", "HTML", "CSS", "Bootstrap"],
    description:
      "Tankwa Vacancy is a companywide job board where users can browse and apply for jobs. It also has a HRM system for managing jobs and applicants information. The app pairs a polished JavaScript interface with a scalable MySQL database and Bootstrap for authentication.",
    features: [
      "Job listings with rich detail pages",
      "Search, filters, and map-friendly layouts",
      "Applicant accounts, job listing drafts, and application tracking",
      "HRM tools for managing jobs and applicants information",
      "MySQL for reliable relational data",
      "Tailwind for styling",
    ],
    screenshots: [
      "/assets/tankwa02.png",
      "/assets/tankwa03.png",
      "/assets/tankwa04.png",
      "/assets/tankwa05.png",
      "/assets/tankwa06.png",
      "/assets/tankwa07.png",
    ],
    websiteLink: "https://tankwatravels.com/applicant/index.php",
    githubLink: "https://github.com/gayalew/vacancy",
    category: "company",
    company: "Tankwa Tours & Travels | Bahir Dar University - BiT",
  },
  {
    slug: "bit_final_year_project",
    imgSrc: "/assets/bit00.png",
    title:
      "BiT Faculty of Computing Students Final Year Project Management System",
    tags: ["React", "Tailwind", "NodeJs", "ExpressJs", "PostgreSQL"],
    description:
      "Bahir Dar University | BiT Students Final Year Project management system. It pairs a polished React interface with a scalable Node.js API and PostgreSQL database.",
    features: [
      "Project management with rich detail pages",
      "Search, filters, and map-friendly layouts",
      "User accounts, role-based access, and project tracking",
      "PostgreSQL for reliable relational data",
      "Tailwind for styling",
    ],
    screenshots: [
      "/assets/bit01.png",
      "/assets/bit02.png",
      "/assets/bit03.png",
      "/assets/bit04.png",
      "/assets/bit05.png",
      "/assets/bit06.png",
    ],
    websiteLink: "https://bit-frontend-tshm.onrender.com",
    githubLink: "https://github.com/gayalew/fyp_front",
    category: "company",
    company: "Tankwa Tours & Travels | Bahir Dar University - BiT",
  },
  {
    slug: "haddis-job-laravel",
    imgSrc: "/assets/project-0.png",
    title: "Haddis-Job (Laravel)",
    tags: ["PHP", "Laravel", "Auth0", "Development"],
    description:
      "An earlier iteration of the Haddis-Job platform built with Laravel and Auth0. It delivers core job-board functionality with server-rendered workflows and third-party identity management.",
    features: [
      "Job CRUD and application tracking",
      "Auth0 integration for sign-in",
      "Laravel MVC architecture",
      "Blade templates and form validation",
      "MySQL database integration",
    ],
    screenshots: [
      "/assets/project-0.png",
      "/assets/project01.png",
      "/assets/project02.png",
      "/assets/project03.png",
      "/assets/project04.png",
    ],
    websiteLink: "https://haddis-job-app.up.railway.app",
    githubLink: "https://github.com/gayalew/Haddis-Job",
    category: "solo",
  },
  {
    slug: "haddis-cocktails",
    imgSrc: "/assets/project-7.png",
    title: "Haddis-Cocktails Landing Page",
    tags: ["React", "CSS", "GSAP"],
    description:
      "A cinematic landing page for a cocktail brand, focused on motion design and scroll-driven storytelling. GSAP powers smooth transitions and engaging micro-interactions throughout the experience.",
    features: [
      "Scroll-triggered GSAP animations",
      "Responsive hero and product sections",
      "Custom CSS layout and typography",
      "Optimized assets for fast load",
      "Mobile-first responsive design",
    ],
    screenshots: [
      {
        type: "video",
        src: "/assets/haddis-cocktail.webm",
        poster: "/assets/project-7.png",
      },
      { type: "image", src: "/assets/project-7.png" },
    ],
    websiteLink: "https://haddis-cocktails.vercel.app",
    githubLink: "https://github.com/gayalew/gsap_cocktails",
    category: "solo",
  },
  {
    slug: "haddis-prompt",
    imgSrc: "/assets/prompt1.png",
    title: "Haddis-Prompt AI Prompt Generator",
    tags: ["Next.js", "Tailwind", "Google Auth"],
    description:
      "An AI prompt generator that helps users craft effective prompts for language models. Built with Next.js, it includes Google authentication and a clean dashboard for saving and reusing prompts.",
    features: [
      "Prompt templates and customization",
      "Google OAuth sign-in",
      "Next.js App Router architecture",
      "Tailwind-styled UI components",
      "Copy-to-clipboard and history support",
    ],
    screenshots: [
      "/assets/prompt1.png",
      "/assets/prompt2.png",
      "/assets/prompt3.png",
      "/assets/prompt4.png",
    ],
    websiteLink: "https://haddis-prompt.vercel.app",
    githubLink: "https://github.com/gayalew/Haddis-Prompt",
    category: "solo",
  },
  {
    slug: "expense-tracker",
    imgSrc: "/assets/project-1.jpg",
    title: "An Expense-Tracker App",
    tags: ["Flutter", "Firebase", "Development"],
    description:
      "A cross-platform mobile app for tracking daily expenses and income. Firebase provides real-time sync and authentication so data stays available across devices.",
    features: [
      "Add, edit, and categorize transactions",
      "Monthly summaries and spending insights",
      "Firebase Auth and Firestore sync",
      "Flutter UI for iOS and Android",
      "Offline-friendly data handling",
    ],
    screenshots: ["/assets/project-1.jpg"],
    websiteLink: null,
    githubLink: "https://github.com/gayalew/Expense-Tracker-App",
    category: "solo",
  },
  {
    slug: "patient-records",
    imgSrc: "/assets/project-2.png",
    title: "Patient Record Management System",
    tags: ["PHP", "CodeIgniter", "MVC"],
    description:
      "A clinic-oriented system for managing patient records, appointments, and medical history. CodeIgniter’s MVC pattern keeps controllers, models, and views organized for maintainability.",
    features: [
      "Patient profiles and visit history",
      "Staff login and access control",
      "Appointment scheduling",
      "Searchable patient database",
      "CodeIgniter MVC structure",
    ],
    screenshots: ["/assets/project-2.png"],
    websiteLink: null,
    githubLink: "https://github.com/gayalew/patientrecords",
    category: "solo",
  },
];

export const getProjectBySlug = (slug) =>
  projects.find((project) => project.slug === slug);

export default projects;
